'use client'

import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { useModalStore } from '@/stores/modal-store'

export function ComingSoonModal() {
	const { activeModal, closeModal } = useModalStore()
	const isOpen = activeModal === 'coming-soon'

	return (
		<Dialog open={isOpen} onOpenChange={open => !open && closeModal()}>
			<DialogContent className="border-white/10 bg-brand-dark sm:max-w-md">
				<DialogHeader className="items-center text-center">
					<DialogTitle className="text-white text-xl">Coming Soon</DialogTitle>
					<DialogDescription className="text-white/60">
						This feature is currently under development. Stay tuned!
					</DialogDescription>
				</DialogHeader>
				<Button
					onClick={closeModal}
					className="w-full bg-brand-blue text-white hover:bg-brand-blue/90"
				>
					Got it
				</Button>
			</DialogContent>
		</Dialog>
	)
}
